"use strict";

const MuniLiftStationsDataListController = function () {
  var inited = false;
  var config = null;

  var init = function (reInitialize = false) {
    if (inited && !reInitialize) {
      render();
    } else {
      inited = true;
      config = {
        prepareDataCallback: _prepareMuniMLiftStations,
        template: "list/muniLiftStationsDataList.njk",
        layerName: "muniLiftStations",
      };
      DataList.init(config);
      initialRender();
      loadListeners();
      DataList.loadDomListeners();
      DataList.loadDomListeners([{ target: ".open-fact-sheet", callback: openFactSheet }]);
    }
  };

  var loadListeners = function () {
    $(".data-list-container").off("click", ".map-button");
    $(".data-list-container").on("click", ".map-button", showMarkerOnMap);

    $(".data-list-container").off("click", ".open-hard-asset-inventory");
    $(".data-list-container").on(
      "click",
      ".open-hard-asset-inventory",
      HardAssetInventoryModalController.onOpenInventoryClick,
    );
  };

  var openFactSheet = function () {
    const id = DataList.getDataFromRow($(this)).id;
    UrlRoutes.go("lift-station-fact-sheet", { id });
    Analytics.sendDataListEvent("open_factsheet", "lift-stations");
  };

  var showMarkerOnMap = function () {
    var $tr = $(this).parents("tr");
    var id = $tr.data("id");

    MapFunctions.openPopupById(id);
    const mapButtonContainer = $(this).parents("td");
    DataList.addAnalyticsToMapIconOnAddress(mapButtonContainer.hasClass("address-col"));
  };

  var initialRender = function () {
    DataList.setSorting("name", false);
    render();
  };

  var render = function () {
    DataList.render(config);
  };

  var _prepareMuniMLiftStations = function (muniLiftStations) {
    for (const liftStation of muniLiftStations) {
      liftStation.lastInspectionDate = liftStation.routine[liftStation.routine.length - 1];
      liftStation.lastInspectionDisplayDate = liftStation.lastInspectionDate
        ? DateTime.dateToGroupDisplayDate(liftStation.lastInspectionDate)
        : null;
    }
    sortMuniLiftStationsBy(muniLiftStations);

    return {
      rows: muniLiftStations,
      options: {},
    };
  };

  var sortMuniLiftStationsBy = function (muniLiftStations) {
    const alphaSorter = SortUtilities.alphaSorter;
    const booleanSorter = SortUtilities.booleanSorter;
    var sortersDict = {
      name: alphaSorter,
      address: alphaSorter,
      type: alphaSorter,
      sump: booleanSorter,
      cof: SortUtilities.cofSorter,
      lastInspectionDate: DateTime.dateComparator,
    };
    DataList.sortWithDict(muniLiftStations, sortersDict);
  };

  return {
    init,
  };
};

module.exports = MuniLiftStationsDataListController();

const DataList = require("../../mapFunctions/dataList");
const SortUtilities = require("../../general/sortUtilities.js");
const MapFunctions = require("../../mapFunctions/mapFunctions.js");
const UrlRoutes = require("../../routes/urlRoutes");
const Analytics = require("../../general/analytics");
const HardAssetInventoryModalController = require("../hardAssetInventoryModalController");
const DateTime = require("../../dateTime");
